class SigninController {
  /**
   *
   * @param $auth
   * @param $state
   */
  constructor(
    $auth,
    $state
  ) {
    'ngInject';
    this.$auth  = $auth;
    this.$state = $state;
    this.lang = JSON.parse(localStorage.getItem('language') || '"PL"');
  }

  $onSubmit(formSignin) {
    this.$auth.authenticate(this.user)
      .then(()=> this.$state.go('booking', {target:'working'}))
      .finally(() => formSignin.$submitted = false );
  }

  changeLang() {
    this.$auth.changeLang(this.lang);
  }

}

export default SigninController;


/** WEBPACK FOOTER **
 ** ./frontend/components/auth/signin/signin.controller.js
 **/